// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"5b2e9257","170":"e99504d0","213":"422d5a4b","261":"4d4fa540","310":"6917ad9a","621":"df7aabae","651":"280541eb","907":"c56efed5"}[chunkId] + ".chunk.js";
};